import { forwardRef } from "react";
import { Button as ArcButton, type ButtonProps } from "../components/arc/button/button";
import styles from "./button.module.css";

export type { ButtonProps, ButtonSize, ButtonVariant } from "../components/arc/button/button";

/**
 * Arc's button in MajiTap's colours. Arc fills a primary button with ink (`--foreground`); the
 * MajiTap design fills it with the accent. The wrapper re-points the two variables Arc's
 * primary uses, on the button only, so Arc's own styles and motion stay untouched.
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button({ className, ...props }, ref) {
  const brand = (props.variant ?? "primary") === "primary" ? styles.accent : undefined;
  return <ArcButton ref={ref} className={[brand, className].filter(Boolean).join(" ") || undefined} {...props} />;
});
